export default __webpack_public_path__ + "static/genti-paes-8c4ffa938c3419c86dc09f13b9b89303.webp";